import {FeatureCollection} from '@turf/turf';
import {
  getCameraBoundingBox,
  normalizePolygonCollection,
  toIGNBBoxString
} from '../../cesiumTools';
import {LayerDatasource, LayerLoadType, LayerType, MapperViewer} from '../../types';

export class HydroSurfaceLayer implements LayerDatasource {

  id = 'hydroSurface';
  name = 'Surface en eau';
  active = false;
  dataSource = new Cesium.GeoJsonDataSource(this.name);
  type = LayerType.DataSource;
  loadType = LayerLoadType.Manual;
  viewer: MapperViewer;

  url = 'https://data.geopf.fr/wfs?version=2.0.0&SERVICE=WFS&REQUEST=GetFeature&OUTPUTFORMAT=json&TYPENAME=BDTOPO_V3:surface_hydrographique&BBOX=';

  previouslyLoadedBbox = null;
  isLoading = false;

  constructor() {}

  onBeforePrint(): void {

  }
  onAfterPrint(): void {

  }

  initialize(viewer: MapperViewer): void {
    this.viewer = viewer;
    viewer.dataSources.add(this.dataSource);
  }

  remove(): void {
    this.viewer.dataSources.remove(this.dataSource);
  }

  loadData(forceReload = false): void {
    if (!this.dataSource) {
      console.error('Viewer not initialized');
      return;
    }

    const bbox = toIGNBBoxString(getCameraBoundingBox(this.viewer));

    if (this.previouslyLoadedBbox === bbox && !forceReload) {
      return;
    }

    this.previouslyLoadedBbox = bbox;

    if (bbox) {
      this.isLoading = true;

      const url = `${this.url}${bbox}`;
      fetch(url)
        .then(res => res.json())
        .then((geojson: FeatureCollection) => {
          this.buildHydroSurface(normalizePolygonCollection(geojson));
        }).catch(error => {
          console.error('[HydroSurfaceLayer] -> (error) -> ', error);
          this.isLoading = false;
        });
    }
  }

  buildHydroSurface(res: FeatureCollection): void {
    this.dataSource.load(res, {
      clampToGround: true,
      fill: Cesium.Color.BLUE.withAlpha(.2),
      stroke: Cesium.Color.TRANSPARENT,
      strokeWidth: 0,
    }).then(() => {
      this.setActive(true);
      this.isLoading = false;
    });
  }

  setActive(active: boolean): void {
    this.active = active;
    this.dataSource.show = active;
  }
}
